import { createAsyncThunk } from '@reduxjs/toolkit'
import { GeoEntity } from '../../@types/geoEntity'
import { getGeoEntity } from '../../clients/geoClient'

const fetchLocation = createAsyncThunk<GeoEntity, string, Record<string, unknown>>(
  'location/fetch',
  async (entityId) => {
    return await getGeoEntity(entityId)
  }
)

export { fetchLocation }
